import { SimpleGrid } from "@chakra-ui/react";
import EssentialProductCardSkeleton from "../../card/product/EssentialProductCardSkeleton";

const BestSellingProductsSectionSkeleton = () => {
  return (
    <SimpleGrid
      w="full"
      columns={{ base: 2, sm: 3, md: 4, xl: 6, "3xl": 8 }}
      gap={{ base: "12px", md: "16px", xl: "24px", "2xl": "32px" }}
    >
      {Array.from({ length: 8 }).map((_, index) => (
        <EssentialProductCardSkeleton key={index} />
      ))}
    </SimpleGrid>
  );
};

export default BestSellingProductsSectionSkeleton;
